import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {IdexService} from 'app/idex.service';
import {Toast} from 'app/shared/toast/toast';
import {TranslateService} from '@ngx-translate/core';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {Router} from '@angular/router';
import {MatAccordion} from '@angular/material/expansion';


@Component({
   selector: 'app-pdpaAgreement',
   templateUrl: './pdpa-agreement.component.html',
   styleUrls: ['../pdpa-policy/pdpa-policy.component.css'],
})

export class PdpaAgreementComponent implements OnInit {
   errorMessage: any;
   agreebutton = false;
   color = 'disable';
   @ViewChild('agree') agree: ElementRef;
   @ViewChild(MatAccordion) accordion: MatAccordion;
   isRegister = false;
   checkRegister = false;
   checkEkyc = false;
   checkNdid = false;
   tabType = 'register';
   isConsent = false;
   isConsentEkyc = false;
   isConsentNdid = false;

   constructor(public toast: Toast,
               public service: IdexService,
               public translate: TranslateService,
               private dialogRef: MatDialogRef<PdpaAgreementComponent>,
               private router: Router,
               @Inject(MAT_DIALOG_DATA) private data: any) {
      if (data) {
         this.isRegister = data.isRegister;
         this.isConsent = data.isConsent;
         this.isConsentEkyc = data.isConsentEkyc;
         this.isConsentNdid = data.isConsentNdid;
      }
   }

   ngOnInit(): void {
      let chkFirstTab = false;
      if (!this.isConsent) {
         this.checkRegister = true;
      } else {
         chkFirstTab = true;
         this.tabType = 'register';
      }

      if (!this.isConsentEkyc) {
         this.checkEkyc = true;
      } else {
         if (!chkFirstTab) this.tabType = 'ekyc';
         chkFirstTab = true;
      }

      if (!this.isConsentNdid) {
         this.checkNdid = true;
      } else {
         if (!chkFirstTab) this.tabType = 'ndid';
         chkFirstTab = true;
      }
   }

   submit() {
      if (!this.isRegister) {
         this.service.updatePdpa(this.isConsent, this.isConsentEkyc, this.isConsentNdid)
            .subscribe((res) => {
               this.toast.success(res);
            }, error => {
               this.toast.error(error);
            });
      }
      this.dialogRef.close(true);
   }

   onScrollCheck(event: any) {
      if (event.offsetHeight + event.scrollTop >= event.scrollHeight) {
         this.agreebutton = true;
         document.getElementById('btn_agree').style.color = 'white';
         document.getElementById('btn_agree').style.backgroundColor = '#2ab4c0';
      }
   }

   onCancel() {
      this.router.navigate(['/login/']);
      this.dialogRef.close(false);
   }

   onAcceptChange(type: string, chkAgree: any) {
      if (type === 'register') {
         this.checkRegister = chkAgree.checked;
         if (this.isConsentEkyc) this.tabType = 'ekyc';
         else if (this.isConsentNdid) this.tabType = 'ndid';
      } else if (type === 'ekyc') {
         this.checkEkyc = chkAgree.checked;
         if (this.isConsentNdid) this.tabType = 'ndid';
      } else if (type === 'ndid') {
         this.checkNdid = chkAgree.checked;
      }

      if (this.checkRegister && this.checkEkyc && this.checkNdid) {
         this.agreebutton = true;
         document.getElementById('btn_agree').style.color = 'white';
         document.getElementById('btn_agree').style.backgroundColor = '#2ab4c0';
      } else {
         this.agreebutton = false;
         document.getElementById('btn_agree').style.color = '';
         document.getElementById('btn_agree').style.backgroundColor = '';
      }
   }
}
